import { FormHelperText } from '@material-ui/core';
import styled from 'styled-components';
import spaces from '../../styles/theme/spaces';
import colors from '../../styles/theme/colors';

export const FormHelperTextValidationStyledWrapper = styled.div`
  margin-top: ${spaces.micro};
  margin-left: ${spaces.extraSmall};
`;

export const FormHelperTextValidationStyled = styled(FormHelperText)`
  display: flex;
  align-items: center;
  margin-left: 0;
  gap: ${spaces.nano};
  transition: color 0.3s ease-in;
  color: ${colors.green['500']};
`;
